import React from "react";
import useSubscriptionAccess from "../../authorization/hooks/useSubscriptionAccess.js";
import SubscriptionRestriction from "./SubscriptionRestriction.jsx";

export default function SubscriptionRouteGate({ children, area }) {
  const { active } = useSubscriptionAccess();
  return active ? children : <SubscriptionRestriction area={area} />;
}
